export interface TimeControl {
  value: string;
  label: string;
  icon: string;
  description: string;
  category: 'bullet' | 'blitz' | 'rapid' | 'classical';
}

export const TIME_CONTROL_PRESETS: TimeControl[] = [
  // Bullet
  { value: '1+0', label: '1 min', icon: '⚡', description: 'Bullet', category: 'bullet' },
  { value: '1+1', label: '1|1', icon: '⚡', description: 'Bullet', category: 'bullet' },
  { value: '2+1', label: '2|1', icon: '⚡', description: 'Bullet', category: 'bullet' },
  
  // Blitz
  { value: '3+0', label: '3 min', icon: '🔥', description: 'Blitz', category: 'blitz' },
  { value: '3+2', label: '3|2', icon: '🔥', description: 'Blitz', category: 'blitz' },
  { value: '5+0', label: '5 min', icon: '🔥', description: 'Blitz', category: 'blitz' },
  { value: '5+3', label: '5|3', icon: '🔥', description: 'Blitz', category: 'blitz' },
  
  // Rapid
  { value: '10+0', label: '10 min', icon: '⏰', description: 'Rapid', category: 'rapid' },
  { value: '10+5', label: '10|5', icon: '⏰', description: 'Rapid', category: 'rapid' },
  { value: '15+10', label: '15|10', icon: '⏰', description: 'Rapid', category: 'rapid' },
  
  // Classical
  { value: '30+0', label: '30 min', icon: '♟️', description: 'Classical', category: 'classical' },
  { value: '30+20', label: '30|20', icon: '♟️', description: 'Classical', category: 'classical' },
];

export const parseTimeControl = (timeControl: string): { minutes: number; increment: number } => {
  const [minutesStr, incrementStr] = timeControl.split('+');
  return {
    minutes: parseInt(minutesStr, 10) || 0,
    increment: parseInt(incrementStr, 10) || 0,
  };
};

export const formatTimeControl = (minutes: number, increment: number): string => {
  return `${minutes}+${increment}`;
};
